import { render, staticRenderFns } from "./RecordDataTable.vue?vue&type=template&id=c291bc6c"
import script from "./RecordDataTable.vue?vue&type=script&lang=js"
export * from "./RecordDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports